export const T = {
  en_GB: {
    tools: (n: number) => `${n} tool${n !== 1 ? "s" : ""}`,
    nearLimit: " (near limit)",
    nextMessageContext: "Next message context",
    systemPrompt: "System prompt",
    messages: (n: number) => `Messages (${n})`,
    text: "↳ text",
    toolReplay: "↳ tool replay",
    toolDefs: (builtin: number, mcp: number) =>
      `Tools (${builtin}${mcp > 0 ? ` + ${mcp} MCP` : ""})`,
    totalContext: "Total context",
    chatTotals: "Chat totals",
    sentReceived: "Sent / received",
    peakContext: "Peak context",
    cost: "Cost",
  },
  nb_NO: {
    tools: (n: number) => `${n} verktøy`,
    nearLimit: " (nær grensen)",
    nextMessageContext: "Kontekst for neste melding",
    systemPrompt: "Systemprompt",
    messages: (n: number) => `Meldinger (${n})`,
    text: "↳ tekst",
    toolReplay: "↳ verktøyhistorikk",
    toolDefs: (builtin: number, mcp: number) =>
      `Verktøy (${builtin}${mcp > 0 ? ` + ${mcp} MCP` : ""})`,
    totalContext: "Total kontekst",
    chatTotals: "Totalt for chatten",
    sentReceived: "Sendt / mottatt",
    peakContext: "Største kontekst",
    cost: "Kostnad",
  },
} as const;
